<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">品牌：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.brandId"
            style="width: 120px"
            @change="initList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in brands"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl mr20">
        <div class="fl lh30">渠道：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.channelId"
            style="width: 120px"
            @change="initList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in channels"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.siteId"
            style="width: 120px"
            @change="changeSiteId"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.terminalId"
            style="width: 120px"
            @change="changeSiteId"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="tar">
      <a-button type="primary" @click="openTheme">网站主题设置</a-button>
    </div>
    <a-drawer v-model:visible="themeVisible" title="网站主题设置" width="500">
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane
          v-for="item in themeData?.themeConfigList"
          :key="item.themeType"
          :tab="item.themeType"
        >
          <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
            <div
              v-for="(list, index) in item.themeConfigDetailList"
              :key="index"
            >
              <a-form-item
                label="关联PC端首页策略"
                v-if="list.subTerminalId === 1"
                required
              >
                <a-select
                  v-model:value="list.homepageId"
                  @change="
                    (e, option) => changeValue(list, option, 'homepageName')
                  "
                  :options="stragePc"
                  placeholder="请选择"
                ></a-select>
              </a-form-item>
              <a-form-item
                label="关联m端首页策略"
                v-if="list.subTerminalId === 2"
                required
              >
                <a-select
                  v-model:value="list.homepageId"
                  :options="strageM"
                  @change="
                    (e, option) => changeValue(list, option, 'homepageName')
                  "
                  placeholder="请选择"
                ></a-select>
              </a-form-item>
              <a-form-item
                label="关联首页策略"
                v-if="list.subTerminalId === null"
                required
              >
                <a-select
                  v-model:value="list.homepageId"
                  @change="
                    (e, option) => changeValue(list, option, 'homepageName')
                  "
                  :options="strageM"
                  placeholder="请选择"
                ></a-select>
              </a-form-item>
              <a-form-item
                label="关联PC端header-导航"
                v-if="list.subTerminalId === 1"
                required
              >
                <a-select
                  v-model:value="list.navId"
                  @change="(e, option) => changeValue(list, option, 'navName')"
                  :options="navPc"
                  placeholder="请选择"
                ></a-select>
              </a-form-item>
              <a-form-item
                v-if="list.subTerminalId === 1"
                label="PC端主题线条颜色"
                required
              >
                <NColorPicker
                  v-model:value="list.lineColor"
                  :modes="['hex']"
                  default-value="#000000"
                  :show-alpha="false"
                />
              </a-form-item>
              <a-form-item
                label="关联m端header-导航"
                v-if="list.subTerminalId === 2"
                required
              >
                <a-select
                  v-model:value="list.navId"
                  @change="(e, option) => changeValue(list, option, 'navName')"
                  :options="navM"
                  placeholder="请选择"
                ></a-select>
              </a-form-item>
              <a-form-item
                v-if="list.subTerminalId === 2"
                label="M端主题线条颜色"
                required
              >
                <NColorPicker
                  v-model:value="list.lineColor"
                  :modes="['hex']"
                  default-value="#000000"
                  :show-alpha="false"
                />
              </a-form-item>
              <a-form-item
                label="关联header-导航"
                v-if="list.subTerminalId === null"
                required
              >
                <a-select
                  v-model:value="list.navId"
                  @change="(e, option) => changeValue(list, option, 'navName')"
                  :options="navM"
                  placeholder="请选择"
                ></a-select>
              </a-form-item>
              <a-form-item
                label="主题线条颜色"
                v-if="list.subTerminalId === null"
                required
              >
                <NColorPicker
                  v-model:value="list.lineColor"
                  :modes="['hex']"
                  default-value="#000000"
                  :show-alpha="false"
                />
              </a-form-item>
            </div>
            <div>
              <a-form-item label="关联topbar" required>
                <a-select
                  v-model:value="item.themeTopbarConfigDetail.topbarId"
                  placeholder="请选择"
                  @change="
                    (e, option) =>
                      changeTopBar(
                        item.themeTopbarConfigDetail,
                        option,
                        'topbarName'
                      )
                  "
                  :options="topBarList"
                />
              </a-form-item>
            </div>
          </a-form>
        </a-tab-pane>
      </a-tabs>
      <div
        :style="{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px'
        }"
      >
        <a-button style="margin-right: 8px" @click="themeVisible = false"
          >取消</a-button
        >
        <a-button type="primary" @click="handleSaveTheme">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { inject, toRefs, watch } from 'vue'
import { NColorPicker } from 'naive-ui'
export default {
  components: { NColorPicker },
  setup() {
    const initState = inject('initState')
    function changeSiteId(value) {
      console.log(value)
      initState.initList()
    }
    watch(
      () => initState.themeVisible,
      () => {
        initState.activeKey = 'vacation'
      }
    )
    return {
      labelCol: { span: 9 },
      wrapperCol: { span: 14 },
      ...toRefs(initState),
      changeSiteId
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
</style>
